import { Sliders } from "lucide-react";
import type { ModuleSpec } from "../types";

/**
 * Workload Settings — queues, agent assignments, and routing rules.
 *
 * Sits in the `team` nav group (alongside Team and Team Insights) because
 * configuring queues and routing is a team-management task, not org admin.
 * Spec id stays `contact-center-settings` so the route
 * `/settings/queue-management` and downstream code references stay stable.
 */
export const contactCenterSettingsSpec: ModuleSpec = {
  id: "contact-center-settings",
  icon: Sliders,
  i18n: {
    namespace: "modules",
    titleKey: "contactCenterSettings.title",
    descriptionKey: "contactCenterSettings.description",
  },
  nav: {
    path: "/settings/queue-management",
    group: "team",
    order: 40,
  },
  permission: {
    action: "manage",
    subject: "organization",
  },
  meta: {
    status: "active",
    description: "Configure queues, agent assignments, and routing rules",
  },
};
